import { colors } from '../../colors';
var pagination = {
  activeColor: colors.pine,
  defaultColor: colors.white
};
export default pagination;